import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Container, Segment, Sticky, Grid, Input, Transition, Divider, Loader } from 'semantic-ui-react';
import { Button, Form, Icon, List, Label } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import TopMenu from '../TopMenu'
import { AppState } from '../../context';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { dbFamMember, dbCaregivers, dbTasks } from '../../firebase';


const ManageFamilyView = () => {
  const someContext = useContext(AppState);
  const {
    correct,
    setCorrect,
    caregivers,
    setCaregivers,
    user,
    firsttimeuser,
    setFirsttimeuser,
    setUser,
    familyMembers,
    tasks,
    name,
    setName,
    seniors
  } = someContext;
  const contextRef = createRef();
  const existsSecondFam = () => {

    return (
      // <div style={{ alignItems: "center" }}>
        <Container>
          <Grid centered>
            <Grid.Row>
              <Grid.Column>
                <Header style={{ textAlign: 'center' }} as="h4" color="grey">
                  <Header.Content >
                    Others Caring for {idList === "" ? "Nobody" : idList.map((id) => returnSeniorName(id))}
                  </Header.Content>
                </Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                {/* <div style={{ marginTop: '10px', marginLeft: '130px', width: '400px' }}> */}
                  {familyMembers[uidString]["secondaryFam"].map(function name(params) {
                    return (

                      <Label size="big" color='green' horizontal style={{ marginLeft: "3px" }}>
                        {familyMembers ? familyMembers[params]["firstName"] : null}
                      </Label>

                    )
                  })}
                  <br />
                {/* </div> */}
                {/* /familymembers/add/caregiver/:userid/:bool */}
                <div style={{ alignItems: 'center' }}>
                <div style={{ marginTop: '10px' }}>
                  <Button style={{ marginBottom: "0px", marginTop: "15px" }}
                    size='huge' as={Link} to={`/familymembers/add/secondfam/${uidString}/1`} center color='gray' horizontal>
                    Add more </Button>
                    <br/>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <Button size="big" as={Link} to={`/familymembers/profile/${uidString}`} color='gray' horizontal>Back </Button>
                </div>
                </div>
              </Grid.Column>
            </Grid.Row>
         </Grid>
        </Container>
      // </div>
      );
  }
  const params = useParams();
  const uidString = params["userid"];
  const idList = familyMembers ? familyMembers[uidString]["seniors"] : ""
  console.log(idList)
  function returnSeniorName(id) {
    if (seniors) { return (seniors[id]["firstName"]) }
    else return ""

  }
  const doesnotexist = () => {
    return (
      <Container>
        <Grid centered>
          <Grid.Row>

            <Header style={{ marginTop: '5px', marginRight: '5px', marginBottom: "0px", marginTop: "15px", textAlign: 'center' }} as="h1" color="grey">
              <Header.Content >
                There are no other family members registered yet!
            </Header.Content>
            </Header>
            <Header style={{ marginBottom: "0px", marginTop: "10px", textAlign: 'center' }} as="h3" color="grey">
              <Header.Content >
                Add others who may be caring for {idList === "" ? "Nobody" : idList.map((id) => returnSeniorName(id))}
              </Header.Content>
            </Header>
          </Grid.Row>
          <Grid.Row alignItems="center">
            <div alignContent="center" alignItems="center" style={{ alignItems: "center", alignContent: "center" }}>
              <Button style={{ marginBottom: "0px", marginTop: "15px" }}
                size='massive' as={Link} to={`/familymembers/add/secondfam/${uidString}/1`} positive center color='green' horizontal>
                Get Started
          </Button>
            </div>
          </Grid.Row>
          <div style={{ marginTop: '10px', width: '400px' }}>
            <Button size="huge" as={Link} to={`/familymembers/profile/${uidString}`} color='gray' horizontal>Back
          </Button>
          </div>
        </Grid>
      </Container>);
  }
  if (familyMembers[uidString]) {
    return (
      <div ref={contextRef}>
        <TopMenu></TopMenu>
        <Sticky context={contextRef} >
          <Grid padded textAlign="center" alignItems="center" style={{ alignItems: "center" }} >
            <Divider hidden />
            {familyMembers[uidString]["secondaryFam"] !== "hi" ? existsSecondFam() : doesnotexist()}
          </Grid>
        </Sticky>
      </div>
    );
  }
  else {
    return null;
  }
};

export default ManageFamilyView;